// extracted by mini-css-extract-plugin
module.exports = {"colorBox":"FulcrumColor__colorBox--3rLPD","textBox":"FulcrumColor__textBox--MP2o1"};